import anime from 'animejs'

let isFirstTime = true

export default container => {
  const sections = container.querySelectorAll('[data-section-change-info]')
  const elements = Array.from(
    container.querySelectorAll('[data-element-switch]')
  )
  const slides = Array.from(container.querySelectorAll('[data-change-slide]'))
  const texts = container.querySelectorAll('[data-change-text]')

  const setActiveSlide = tag => {
    slides.forEach(slide => {
      const isActive =
        slide.dataset.inputTag.toLowerCase() ===
        tag.dataset.outputTag.toLowerCase()

      slide.classList.toggle('fade-in-slide--active', isActive)

      if (isActive && !isFirstTime) {
        const elementOffset = slide.getBoundingClientRect().top
        const scrollPosition = window.scrollY
        const documentTop = document.documentElement.clientTop
        const scrollOffset = elementOffset + scrollPosition - documentTop
        const squeezeItems = slide.querySelectorAll('.squeeze__title')

        if (squeezeItems.length < 1) {
          return
        }

        const event = new Event('click')

        if ([...squeezeItems][0].ariaExpanded === 'false') {
          squeezeItems[0].dispatchEvent(event)
        }

        anime({
          targets: [document.documentElement, document.body],
          scrollTop: scrollOffset,
          duration: 400,
          easing: 'cubicBezier(0.25, 0.1, 0.25, 1.0)',
        })
      }
    })
  }

  const removeActiveClass = () => {
    const elementWithActive = elements.find(element =>
      element.classList.contains('is-active')
    )

    elementWithActive.classList.remove('is-active')
  }

  const actualBg = element =>
    slides.find(
      item =>
        element.dataset.outputTag.toLowerCase() ===
        item.dataset.inputTag.toLowerCase()
    )

  const changeText = items => {
    items.forEach(text => {
      if (text.parentNode.classList.contains('is-active')) {
        text.textContent = window.globaljetBookingTranslation['Read less']
      } else {
        text.textContent = window.globaljetBookingTranslation['Read more']
      }
    })
  }

  sections.forEach(s => {
    s.style.backgroundImage = `url(${
      actualBg(elements[0]).dataset.changeSlide
    })`
  })
  setActiveSlide(elements[0])
  changeText(texts)

  elements.forEach(element => {
    element.addEventListener('click', () => {
      isFirstTime = false
      sections.forEach(section => {
        removeActiveClass()
        element.classList.add('is-active')
        changeText(texts)

        setTimeout(() => {
          section.style.backgroundImage = `url(${
            actualBg(element).dataset.changeSlide
          })`
          setActiveSlide(element)
        }, 200)
      })
    })
  })
}
